import { createAsyncThunk } from '@reduxjs/toolkit';
import {HOSTNAME} from "../configs/Domain";
import _ from "lodash";
import axios from "axios";

// Define the async thunk
export const fetchFilteredTickers = createAsyncThunk(
  'tickers/fetchFiltered',
  async (mongoQuery, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/tickers/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(mongoQuery),
      });
      console.log("RESPONSE FROM fetchFilteredTickers", response)

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      console.log('fetchFilteredTickers data:', data);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchTickerData = createAsyncThunk(
  'tickers/fetchTickerData',
  async ({ symbols, fields, collection }, { getState }) => {
    const state = getState().tickers;
    if (!fields.includes('symbol')) {
      fields.unshift('symbol');
    }

    let symbolsToFetch = symbols.filter(symbol => {
      const existingTicker = state.tickers[symbol];
      return !existingTicker || fields.some(field => !_.has(existingTicker, field));
    });

    if (symbolsToFetch.length === 0) {
      return { fetchedTickers: [], badTickers: [] };
    }

    let params = {
      symbols: symbolsToFetch.join(','),
      fields: fields.join(',')
    }
    if (collection) {
      params.collection = collection;
    }

    const response = await axios.get(`${HOSTNAME}/tickers/find`, { params: params });
    const fetchedSymbols = response.data.map(ticker => ticker.symbol);
    const badTickers = symbolsToFetch.filter(symbol => !fetchedSymbols.includes(symbol));

    return { fetchedTickers: response.data, badTickers };
  }
);



export const fetchETFs = createAsyncThunk('etfs/fetchETFs', async (symbols, { getState }) => {
  const queryString = symbols.join(',');
  const response = await fetch(`${HOSTNAME}/tickers/find?symbols=${queryString}&fields=symbol,name,holdings,tags,metrics,specs,stats.summary.ytd,stats.benchmarks.spy.corr_1_yr,logo`);
  if (!response.ok) throw new Error('Failed to fetch ETF data');
  return response.json();
});


export const fetchXrayData = createAsyncThunk(
  'tickers/fetchXrayData',
  async (symbols, { rejectWithValue }) => {
      const queryStringFromObject = (obj)=>{
          console.log(obj)
          return Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&');
      }
    console.log('fetchXrayData:', symbols)
    try {
      let finalWeights = {};

      if (!Array.isArray(symbols) && typeof symbols === 'object') {
        // Assuming you have a helper to convert object to query string
            finalWeights = symbols;
      } else if (Array.isArray(symbols)) {
        let equalWeight = 1 / symbols.length;
        symbols.forEach(x=>{
            finalWeights[x] = equalWeight;
        });
        console.log('finalWeights:', finalWeights)
      } else {
        throw new Error('Invalid input for symbols');
      }
      const queryString = queryStringFromObject(finalWeights);

      const response = await axios.get(`${HOSTNAME}/tickers/xray?${queryString}`);
      if (!response.data) throw new Error('No data received from server');

      const data = response.data;
      // Assuming 'parents' is a valid key that needs to be modified
      if (data.parents) {
        for (let k in data.parents) {
          if (finalWeights.hasOwnProperty(k)) {
            data.parents[k].wgt = finalWeights[k];
          }
        }
      }

      return data;
    } catch (error) {
      console.error('Error in fetchXrayData:', error);
      return rejectWithValue(error.toString());
    }
  }
);



export const fetchUpcomingEvents = createAsyncThunk('etfs/fetchUpcomingEvents', async (tickers, { getState }) => {
    const { user } = getState();
    if (user.upcomingEvents){
        return user.upcomingEvents;
    }
    const queryString = `symbols=${tickers.join(',')}`;

    const response = await fetch(`${HOSTNAME}/tickers/calendar?${queryString}`);
    if (!response.ok) throw new Error('Failed to fetch ETF data');
    const data = await response.json();
    return data;
});
